export const app_config = {
    DASHBOARD_LISTS_ITEM_COUNT : 3,
    FOOTER_HEIGHT : 56,
}
